<script setup>
  import { computed } from 'vue'

  const props = defineProps({
    media: String
  })

  const media = computed(() => {
    const parsedMedia = JSON.parse(props.media)
    return {
      'element': parsedMedia['element'],
      'imageUrl': parsedMedia['image-url'],
      'imageAlt': parsedMedia['image-alt']
    }
  })
</script>

<template>
  <section
    class="element-gallery ~mt-20/28 max-w-screen-2xl mx-auto px-6"
  >
    <GridLayout>
      <div
        class="element-gallery-item col-span-1 lg:col-span-8 lg:col-start-5"
      >
        <Media
          :media="media"
        />
      </div>
    </GridLayout>
  </section>
</template>

<style lang="scss" scoped>

</style>
